export default __webpack_public_path__ + "static/media/Collab5.6d01051c.png";